import { z } from 'zod';

/** Identifiant de connexion : courriel ou téléphone, normalisé en minuscules sans espaces de bordure. */
export const schemaIdentifiant = z
  .string()
  .trim()
  .min(3, 'Identifiant trop court')
  .max(254, 'Identifiant trop long')
  .transform((v) => v.toLowerCase());

/** Règle minimale de mot de passe : 12 caractères, au moins une lettre et un chiffre. */
export const schemaNouveauMotDePasse = z
  .string()
  .min(12, 'Le mot de passe doit contenir au moins 12 caractères')
  .max(256, 'Le mot de passe est trop long')
  .regex(/[A-Za-zÀ-ÿ]/, 'Le mot de passe doit contenir au moins une lettre')
  .regex(/[0-9]/, 'Le mot de passe doit contenir au moins un chiffre');

export const schemaConnexion = z.object({
  identifiant: schemaIdentifiant,
  mot_de_passe: z.string().min(1, 'Mot de passe obligatoire').max(256),
  appareil: z.string().max(200).optional(),
});
export type DemandeConnexion = z.infer<typeof schemaConnexion>;

export const schemaVerificationMfa = z
  .object({
    jeton_temporaire: z.string().min(10),
    code: z
      .string()
      .regex(/^\d{6}$/, 'Code à six chiffres attendu')
      .optional(),
    code_secours: z.string().trim().min(8).max(32).optional(),
  })
  .refine((v) => Boolean(v.code) !== Boolean(v.code_secours), {
    message: 'Fournir soit un code TOTP, soit un code de secours',
  });
export type DemandeVerificationMfa = z.infer<typeof schemaVerificationMfa>;

export const schemaConfirmationMfa = z.object({
  code: z.string().regex(/^\d{6}$/, 'Code à six chiffres attendu'),
});

export const schemaDesactivationMfa = z.object({
  mot_de_passe: z.string().min(1, 'Mot de passe obligatoire').max(256),
});

/** Réponse d'une connexion aboutie (session créée). */
export const schemaSessionOuverte = z.object({
  etape: z.literal('connecte'),
  jeton_acces: z.string(),
  expire_dans: z.number().int(),
  session_id: z.string().uuid(),
});
export type SessionOuverte = z.infer<typeof schemaSessionOuverte>;

/** Réponse intermédiaire lorsque le second facteur est exigé. */
export const schemaEtapeMfa = z.object({
  etape: z.literal('mfa'),
  jeton_temporaire: z.string(),
  expire_dans: z.number().int(),
});
export type EtapeMfa = z.infer<typeof schemaEtapeMfa>;

export const DUREE_JETON_ACCES_SECONDES = 15 * 60;
export const DUREE_JETON_MFA_SECONDES = 5 * 60;
